// third-party

// assets
import {
	AuditOutlined,
	SolutionOutlined,
	ReadOutlined,
	GroupOutlined,
	FundProjectionScreenOutlined,
	ReconciliationOutlined,
	FileDoneOutlined
} from '@ant-design/icons';
import useAuthContext from 'context/useAuthContext';

// type
import { NavItemType } from 'layout/mantis/types/MenuType';

// icons
const icons = {
	reconciliationOutlined: ReconciliationOutlined,
	solutionOutlined: SolutionOutlined,
	readOutlined: ReadOutlined,
	fundProjectionScreenOutlined: FundProjectionScreenOutlined,
	groupOutlined: GroupOutlined,
	auditOutlined: AuditOutlined,
	fileDoneOutlined: FileDoneOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export default function CertificationMenuItems() {
	const { permissions, roles } = useAuthContext();
	let items: NavItemType = {};

	if (permissions) {
		if (
			permissions.some((el: string) => {
				return el === 'View_Certifications' || el === 'Manage_Certifications' || el === 'Search_Reports';
			})
		) {
			items = {
				id: 'group-certifications',
				title: 'Certifications',
				type: 'group',
				icon: icons.fileDoneOutlined,
				children: []
			};

			if (
				permissions.some((el: string) => {
					return el === 'View_Certifications' || el === 'Manage_Certifications';
				})
			) {
				items.children.push({
					id: 'core-certification-list-issue',
					title: 'Issued Certificates',
					type: 'item',
					url: '/app/certification/issue',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
			}

			if (
				permissions.some((el: string) => {
					return el === 'Manage_Certifications';
				})
			) {
				items.children.push({
					id: 'core-certification-list-templates',
					title: 'Certificate Templates',
					type: 'item',
					url: '/app/certification/templates',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
			}

			if (
				permissions.some((el: string) => {
					return el === 'Search_Reports';
				})
			) {
				items.children.push({
					id: 'core-reports-certificate-verify',
					title: 'Verify Certificate',
					type: 'item',
					url: '/app/reports/certificate/verify',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
			}
			if (
				permissions.some((el: string) => {
					return el === 'Search_Reports';
				})
			) {
				items.children.push({
					id: 'core-reports-certificate-missing',
					title: 'Missing Certificate',
					type: 'item',
					url: '/app/reports/certificate/missing',
					icon: icons.solutionOutlined,
					breadcrumbs: true
				});
			}
		}
	}

	return items;
}
